import {CanActivate} from '@angular/router';
import {Injectable} from '@angular/core';

import {Observable, of} from 'rxjs';
import {catchError, filter, switchMap, take, tap} from 'rxjs/operators';
import {select, Store} from '@ngrx/store';

import {ApplicationState} from '../../application-state/store';
import {AnalysisResultsActions} from '../store';
import {AnalysisResultsSelectors} from '../store/selectors';

@Injectable()
export class AnalysisResultsLoadedGuard implements CanActivate {

  constructor(private store: Store<ApplicationState>) {
  }

  canActivate(): Observable<boolean> {

    return this.loadAnalysisResultsDone().pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
  }

  loadAnalysisResultsDone() {

    return this.store.pipe(
      select(AnalysisResultsSelectors.isLoaded),
      tap((loaded: boolean) => {
        if (!loaded) {
          this.store.dispatch(AnalysisResultsActions.ReadAnalysisResults());
        }
      }),
      filter(loaded => loaded),
      take(1)
    );
  }
}
